import type {EnrichedRooftopData} from "../../types/solar";
import type {ConfirmedPanelsDataSlim, SlimmedConfirmedRooftopData} from "@shared/interfaces/solar";
import {createLogger} from "../logger.ts";

const logger = createLogger("PanelManager");

const panelsData: EnrichedRooftopData[] = [];

export const initPanels = (initialPanelsData?: ConfirmedPanelsDataSlim, initialRooftopData?: SlimmedConfirmedRooftopData) => {
    if (!initialPanelsData || !initialRooftopData) {
        logger.error('Initial Panels and Rooftop data must be defined');
        return;
    }
    initialRooftopData.panelInstallationAreas.sort((a, b) => {
        if (!a.properties.orientationDegrees || !b.properties.orientationDegrees) {
            return -1;
        }

        return Math.abs(a.properties.orientationDegrees - 180) - Math.abs(b.properties.orientationDegrees - 180);
    });

    initialRooftopData.panelInstallationAreas.forEach((area) => {
        panelsData.push({
            rooftopId: area.properties.id,
            // SYSTEM_OPTIMISATION_TYPE_PV_AND_BATTERY: initialPanelsData.SYSTEM_OPTIMISATION_TYPE_PV_AND_BATTERY[area.properties.id],
            SYSTEM_OPTIMISATION_TYPE_PV_ONLY: initialPanelsData.SYSTEM_OPTIMISATION_TYPE_PV_ONLY[area.properties.id],
        } as EnrichedRooftopData);
    });

    logger.debug('Panel data loaded', { panelsData });
}

export const getPanelStates = (amount: number) => {
    const enabledPanels: string[] = [];
    panelsData.forEach((rooftop) => {
        if (amount <= enabledPanels.length) {
            return;
        }

        const panelsGrid = rooftop.SYSTEM_OPTIMISATION_TYPE_PV_ONLY.panelsGrid;
        Object.keys(panelsGrid).forEach((panelKey) => {
            if (amount <= enabledPanels.length) {
                return;
            }
            enabledPanels.push(panelsGrid[panelKey].id!.toString());
        });
    });

    return enabledPanels;
}